<template>
  <DBox
    :id="'cmp-distribution-accounts-account_sidewindow-statement_history_list'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="`${$t('add_new')} ${$t('Order')}`"
    @addClick="onAddClick"
  >
    <NTable
      class="dbox1"
      :id="'distribution-accounts-account_sidewindow-order_list'"
      :items="list"
      :config="tableConfig"
      :headers="headers"
      :showNoItems="false"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('orders')">
            <span
              @click.stop="e => onSelectedOrder(item)"
              class="txtov ut-link ut-text-accent5"
              :title="item['order_date']"
            >
              {{ item["order_date"] }}
            </span>
          </td>
          <td v-bind="tdcon('order_ref')">
            <span class="txtov" :title="item['order_id']">
              {{ item["order_id"] }} &nbsp;
              {{ item["order_type_name"] }}
            </span>
          </td>
          <td v-bind="tdcon('client')">
            <span class="txtov" :title="item['address']">
              {{ item["address"] }}
            </span>
          </td>
          <td v-bind="tdcon('status')">
            <span class="txtov" :title="item['status']">
              {{ item["status"] }}
            </span>
          </td>
          <td v-bind="tdcon('value')">
            <span class="txtov" :title="item['order_value']">
              {{
                item["order_value"]
                  ? $dft.curr(item["order_value"])
                  : item["order_value"]
              }}
            </span>
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>

<script>
import NTable from "@/plugins/datatable/datatable";
import {
  createNTableConfig,
  createTableHeader
} from "../../../../plugins/datatable";
import TextInput from "../../../../plugins/text-field/text-input";
import AddOrder from "./add-order";
import { distributionOrderListLDTRoutes } from "../../router/routes";
export default {
  components: {
    NTable,
    TextInput,
    AddOrder
  },
  props: ["selectedAccountsDetails"],
  data: function() {
    return {
      selectedInvoice: {},
      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true,
        footer: false
      }),
      // order_types: [
      //   {
      //     value: 1,
      //     label: "Invoice Order",
      //     textkey: "ot_invoice_order"
      //   },
      //   {
      //     textkey: "ot_consignment",
      //     label: "Consignment",
      //     value: 2
      //   },
      //   {
      //     value: 3,
      //     textkey: "ot_return_credit_note",
      //     label: "Return Credit Note"
      //   },
      //   {
      //     value: 4,
      //     label: "Consignment Return",
      //     textkey: "ot_return_consignment"
      //   },
      //   {
      //     value: 5,
      //     label: "Promo Order",
      //     textkey: "ot_promo_order"
      //   },
      //   {
      //     value: 6,
      //     textkey: "ot_defects_note",
      //     label: "Defects Note"
      //   },
      //   {
      //     value: 7,
      //     textkey: "ot_defects_consignment",
      //     label: "Defects Consignment"
      //   },
      //   {
      //     label: "Price Adjustment",
      //     textkey: "ot_price_adjustment",
      //     value: 8
      //   },
      //   {
      //     value: 9,
      //     textkey: "ot_statement",
      //     label: "Invoice Consignment"
      //   },
      //   {
      //     textkey: "ot_ret_to_vendor",
      //     label: "Return to vendor",
      //     value: 10
      //   }
      // ],
      addOrderModalContainer: false
    };
  },
  computed: {
    list: function() {
      return this.selectedAccountsDetails?.orders
        ? this.selectedAccountsDetails.orders.map(o => {
            // o.order_type_name = this.order_types.find(
            //   od => od.value === o.order_type
            // ).label;
            o.address = `${o.deliver_company ? o.deliver_company : ""} ${
              o.deliver_name ? o.deliver_name : ""
            } ${o.deliver_address1 ? o.deliver_address1 : ""} ${
              o.deliver_address2 ? o.deliver_address2 : ""
            }`.trim();
            return o;
          })
        : [] || [];
    },
    headers: function() {
      return [
        createTableHeader("orders", { f: 0.7, mw: 100 }),
        createTableHeader("order_ref"),
        createTableHeader("client", { minw: 350 }),
        createTableHeader("status"),
        createTableHeader("value", { ta: "right", text: "Value EUR" })
      ];
    }
  },
  methods: {
    onSelectedOrder: function(item) {
      this.$router.push({
        name: distributionOrderListLDTRoutes.names.tab,
        params: {
          order_id: item.order_id,
          tab: "overview"
        }
      });
    },
    onAddClick: function() {
      this.$emit("add_click", "add_order_form");
    },
    onAddAccountOrderCancelled: function() {
      this.$router.push({
        ...this.$route,
        query: {
          modal: undefined,
          account_id: undefined,
          external_table: undefined
        }
      });
    },
    onAccountOrderAdded: function(item) {
      this.selectedAccountData.orderList.push(item);
      this.onAddOrderCancelled();
    },
    onDeleteOrderItem: function(item) {}
  }
};
</script>
<style lang="scss" scoped>
.cmp-distribution-accounts-account_sidewindow-order_list {
  .order-list {
    --ntable-height: 620px !important;
    --tb-layout: fixed;
    tr {
      padding-left: 5px;
    }
    td:last-child,
    th:last-child {
      width: 50px !important;
    }

    td.name {
      color: black !important;
      font-weight: 800 !important;
    }
  }
  .dt-table.ind-table {
    td:nth-child(5),
    th:nth-child(5) {
      width: 50px !important;
    }
  }
}
</style>
